export { default as ChangeAvatarRouteContainer } from "./containers/ChangeAvatarRouteContainer";
export * from "./dialogs/ChangeAvatarDialog";
